





































































































































































































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
//  @types
import { ExtendedVessel } from "@/types/vessel";
import { VesselEvent } from "@/types/vesselEvent";
import { IVesselLongTrend } from "@/types/vesselLongTrends";
import { ILongTrendPeriod } from "@/types/longTrendPeriod";
import { ILongTrend } from "@/types/longTrend";
import { SpeedLogSensorQuality } from "@/types/dataQuality/SpeedLogSensorQuality";
import { FoulingAddedConsumption } from "@/types/FoulingAddedConsumption";
import { SpeedLossStatistic } from "@/types/SpeedLossStatistic";
import { IStatusCard } from "@/types/StatusCard";
//  @components
import OverallVesselPerformanceStatus from "@/components/diagnostics/OverallVesselPerformanceStatus.vue";
import StatusCard from "@/components/diagnostics/StatusCard.vue";
import VesselEventModal from "@/components/VesselEventModal.vue";
import ManageEventsModal from "@/components/ManageEventsModal.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import DiagnosticCard from "@/components/DiagnosticCard.vue";
import DiagnosticsDetails from "@/components/diagnosticsDetails/DiagnosticsDetails.vue";
import FeatureNotAvailable from "@/components/FeatureNotAvailable.vue";
import ChangeInShaftPowerCard from "@/components/diagnostics/ChangeInShaftPowerCard.vue";
import OperationalProfileCard from "@/components/diagnostics/OperationalProfileCard.vue";
import HullCoatingModal from "@/components/diagnostics/modals/HullCoatingModal.vue";
//  @clients
import LongTrendExportClient from "@/Scripts/clients/long-trend-export-client";
// Diagnostics - for OperationalProfileCard syncing / watcher
import { DiagnosticsChartConfig } from "@/types/DiagnosticsChartConfig";
//  @modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import FoulingModule from "@/store/clients/Diagnostics.module";
import LongTrendsModule from "@/store/clients/LongTrends.module";
import VesselEventsModule from "@/store/clients/VesselEvents.module";
import SnackbarModule from "@/store/clients/Snackbar.module";
import LogVariablesModule from "@/store/clients/LogVariables.module";
import DataQualityModule from "@/store/clients/DataQuality.module";
import DiagnosticsModule from "@/store/clients/Diagnostics.module";

const Vessels = getModule(VesselsModule, store);
const Fouling = getModule(FoulingModule, store);
const VesselEvents = getModule(VesselEventsModule, store);
const LongTrends = getModule(LongTrendsModule, store);
const LogVariables = getModule(LogVariablesModule, store);
const DataQuality = getModule(DataQualityModule, store);
const Snackbar = getModule(SnackbarModule, store);
const Diagnostics = getModule(DiagnosticsModule, store);

export interface IVesselLongTrendsExtended extends IVesselLongTrend {
  visible: boolean;
}

@Component({
  components: {
    OverallVesselPerformanceStatus,
    StatusCard,
    VesselEventModal,
    ManageEventsModal,
    ConfirmDialog,
    DiagnosticCard,
    DiagnosticsDetails,
    FeatureNotAvailable,
    ChangeInShaftPowerCard,
    OperationalProfileCard,
    HullCoatingModal,
  },
})
export default class DiagnosticsView extends Vue {
  @Ref("VesselEventModal") VesselEventModal!: any;
  @Ref("ConfirmDelete") ConfirmDelete!: any;
  @Ref("DiagnosticsDetails") DiagnosticsDetails!: any;
  @Ref("OperationalProfileCard") OperationalProfileCard!: any;
  @Ref("HullCoatingModal") HullCoatingModal!: any;

  //  @Data
  overview = "Overview";
  currentLongTrend = "ShipSpeedDev";
  isDataLoading = true;
  isVesselEventModal = false;
  ManageEventsModal = false;
  hasFilterUpdated = false;
  exportExcelLoading = false;
  selectedDiagnosticsTrend: string | null = null;
  HullCoatingModalActive = false;
  operationalProfileDateRange: string[] = [];
  diagnosticsChartConfig: DiagnosticsChartConfig = {} as DiagnosticsChartConfig;
  addedFuelConsumptions: FoulingAddedConsumption[] | null = null;
  speedLogQuery: { imo: number; from: string; to: string } = {
    imo: this.currentVessel?.imoNumber ?? 0,
    from: moment.utc().subtract(7, "day").format("YYYY-MM-DD"),
    to: moment.utc().format("YYYY-MM-DD"),
  };

  // @Watchers
  @Watch("getDiagnosticsChartConfig", { deep: true })
  onDiagnosticsChartConfigChanged(): void {
    this.diagnosticsChartConfig = JSON.parse(JSON.stringify(this.getDiagnosticsChartConfig));
    this.operationalProfileDateRange = [this.getDiagnosticsChartConfig.opFromDate, this.getDiagnosticsChartConfig.opToDate];
  }

  // Diagnostics getter used by the watcher above
  get getDiagnosticsChartConfig(): DiagnosticsChartConfig {
    return Diagnostics.diagnosticsChartConfig;
  }

  //  @Getters
  get currentVessel(): ExtendedVessel | null {
    return Vessels.currentVessel;
  }

  get speedLogData(): SpeedLogSensorQuality {
    return DataQuality.speedLogData;
  }

  get sensorQualityStatus(): string {
    if (!this.speedLogData?.data || this.speedLogData?.data.length === 0) return "N/A";
    const lastSpeedPoint = this.speedLogData.data[this.speedLogData.data.length - 1].bias ?? 0;
    if (lastSpeedPoint >= -5 && lastSpeedPoint <= 5) return "Good Quality";
    if (lastSpeedPoint > 10 || lastSpeedPoint < -10) return "Poor Quality";
    if ((lastSpeedPoint > 5 && lastSpeedPoint <= 10) || (lastSpeedPoint < -5 && lastSpeedPoint >= -10)) return "Degrading Quality";

    return "N/A";
  }

  get isDiagnosticsEnabled(): boolean {
    if (!this.currentVessel || !this.currentVessel.features) return false;
    return this.currentVessel.features.some(feature => feature.name === "Diagnostics");
  }

  get isDataQualityEnabled(): boolean {
    if (!this.currentVessel || !this.currentVessel.features) return false;
    return this.currentVessel.features.some(feature => feature.name === "DataQuality");
  }

  get vesselLongTrends(): IVesselLongTrendsExtended[] {
    if (!LongTrends.vesselLongTrends) return [];
    return Object.values(LongTrends.vesselLongTrends)
      .filter(trend => trend && trend.longTrend && Object.keys(trend.longTrend).length > 0)
      .map(trend => ({
        ...trend,
        visible: true,
      }));
  }

  get latestTrendEvent(): VesselEvent {
    return VesselEvents.trendEvents[0];
  }

  get speedLossStatistics(): SpeedLossStatistic[] {
    return Diagnostics.speedLossStatistics;
  }

  get latestSpeedLossStatistics(): SpeedLossStatistic | null {
    return this.speedLossStatistics[this.speedLossStatistics.length - 1] ?? null;
  }

  get isBenchmarking(): boolean {
    if (!this.diagnosticsChartConfig) return false;
    // Optional-chain benchmark before accessing `end`
    return !this.latestSpeedLossStatistics?.benchmark?.end && !this.diagnosticsChartConfig.useManualBenchmark;
  }

  get latestAddedConsumption(): FoulingAddedConsumption | undefined {
    if (!this.addedFuelConsumptions) return;
    // Ensure we optional-chain benchmark as well to avoid accessing `.level` on undefined
    const filteredFuelConsumptions = this.addedFuelConsumptions.filter(
      c => c.usingDerivedStw === this.diagnosticsChartConfig.useDerivedStw && c.benchmarkLevel === this.latestSpeedLossStatistics?.benchmark?.level
    );
    return filteredFuelConsumptions[filteredFuelConsumptions.length - 1];
  }

  get cumulativeAddedFuelConsumption(): string | undefined {
    if (!this.latestAddedConsumption || !this.latestTrendEvent || this.isBenchmarking) return;
    if (this.latestAddedConsumption.fromDate !== this.latestTrendEvent.timestamp) {
      return "N/A";
    }
    const roundedNumber = Math.round(Number(this.latestAddedConsumption.cumulativeAddedConsumption));
    return roundedNumber.toLocaleString();
  }

  get statusCardDataList(): IStatusCard[] {
    if (!this.currentLongTrend) return [] as IStatusCard[];
    const trend = this.vesselLongTrends.find(trend => trend.longTrend.name === this.currentLongTrend);
    if (!trend) return [] as IStatusCard[];
    const statusCardDataList: IStatusCard[] = [
      {
        status: trend.longTrend.performanceStatus,
        header: "Performance Status",
        content: this.convertStatusStr(trend.longTrend.performanceStatus),
        contentPrependIcon: this.longTrendPerformanceIcon(trend.longTrend),
        contentPrependIconColor: "BackgroundInfoPrimary",
        footer: this.showPrediction ? this.showPredictionByStatus : "",
        footerSeparator: this.showPrediction,
      },
      {
        header: this.currentLongTrendShortDescription,
        content: this.latestLongTrendPeriodValue,
        footer: "compared to baseline",
        footerTooltip: "Baseline is vessel's 0% performance e.g. from model tank test",
      },
      {
        header: "Cumulative Added Consumption",
        headerTooltip: "Total extra fuel consumed due to speed loss during the latest trend period",
        content: this.cumulativeAddedFuelConsumption ?? "N/A",
        footer: "compared to benchmark",
      },
      {
        header: "Speed Log Quality",
        headerTooltip: "Speed Log Quality shows how reliable the speed sensor’s data is",
        content: this.isDataQualityEnabled ? this.sensorQualityStatus : "Data Quality Not Activated",
        footerLink: this.isDataQualityEnabled ? `/DataQuality/SpeedLog?find=${this.currentVessel?.name}` : "mailto:sales@gttmarine.fr",
        footerLinkText: this.isDataQualityEnabled ? "Go to Data Quality" : "Contact sales@gttmarine.fr",
        footerSeparator: true,
      },
    ];
    if (!this.isSpeedLossChart) {
      // Remove both cards by header
      return statusCardDataList.filter(card => card.header !== "Speed Log Quality" && card.header !== "Cumulative Added Consumption");
    }
    return statusCardDataList;
  }

  get longTrend(): ILongTrend {
    return LongTrends.vesselLongTrendByName(this.currentLongTrend ?? "")?.longTrend ?? ({} as ILongTrend);
  }

  get diagnosticsDetailsLongTrendPeriods(): ILongTrendPeriod[] {
    if (!this.selectedDiagnosticsTrend) return [];
    const trend = this.vesselLongTrends.find(t => t.longTrend.name === this.selectedDiagnosticsTrend);
    return trend?.longTrendPeriods ?? [];
  }

  get longTrendPeriods(): ILongTrendPeriod[] {
    if (!this.currentLongTrend) return [];
    return this.longTrend ? LongTrends.vesselLongTrendByName(this.currentLongTrend ?? "")?.longTrendPeriods ?? ([] as ILongTrendPeriod[]) : [];
  }

  get latestLongTrendPeriod(): ILongTrendPeriod | null {
    if (!this.longTrendPeriods || !this.longTrendPeriods.length) return null;
    return this.longTrendPeriods[this.longTrendPeriods.length - 1];
  }

  get latestLongTrendPeriodValue(): string {
    return this.latestLongTrendPeriod && this.latestLongTrendPeriod.trendline ? `${this.latestLongTrendPeriod.trendline.end.y.toFixed(1)}${this.latestLongTrendPeriod.unitCaption}` : "N/A";
  }

  get currentLongTrendShortDescription(): string {
    if (!this.currentLongTrend) return "";
    const trend = this.vesselLongTrends.find(trend => trend.longTrend.name === this.currentLongTrend);
    if (!trend) return "";
    return trend.longTrend.description.split(",")[0] ?? "";
  }

  get isSpeedLossChart(): boolean {
    if (!this.currentLongTrend) return false;
    return this.currentLongTrend === "ShipSpeedDev";
  }

  get showPrediction(): boolean {
    if (!this.latestLongTrendPeriod?.isCurrent) return false;
    if (this.showYellowPrediction || this.showRedPrediction) return true;
    return false;
  }

  get showYellowPrediction(): boolean {
    if (!this.latestLongTrendPeriod?.redLineReached) return true;
    const redLineReached = new Date(this.latestLongTrendPeriod?.redLineReached).getTime();
    if (redLineReached > Date.now()) return true;
    return false;
  }

  get showRedPrediction(): boolean {
    // Guard: if we don't have a yellowLineReached value, preserve original intent of returning true
    if (!this.latestLongTrendPeriod?.yellowLineReached) return true;

    // At this point yellowLineReached exists - safe to access without optional chaining
    const yellowLineReached = new Date(this.latestLongTrendPeriod.yellowLineReached).getTime();

    // Ensure start exists before using it
    const startStr = this.latestLongTrendPeriod?.start;
    if (!startStr) return true; // if start is unknown, keep original conservative behavior

    const startTime = new Date(startStr).getTime();

    if (yellowLineReached > Date.now() || yellowLineReached < startTime) return true;
    return false;
  }

  get yellowPrediction(): string {
    if (!this.latestLongTrendPeriod?.yellowLineReached) return '"Observe" not expected soon';
    const reachedDate = new Date(this.latestLongTrendPeriod.yellowLineReached).getTime();

    const startStr = this.latestLongTrendPeriod?.start;
    if (!startStr) return '"Observe" not expected soon';
    const startTime = new Date(startStr).getTime();

    if (reachedDate < startTime) return '"Observe" not expected soon';
    if (reachedDate < Date.now()) {
      return `"Observe" was reached on ${this.$options.filters?.dateDMY(this.latestLongTrendPeriod?.yellowLineReached)}.`;
    } else {
      return `Changes to "Observe" ${this.$options.filters?.dateDMY(this.latestLongTrendPeriod?.yellowLineReached)}.`;
    }
  }

  get redPrediction(): string {
    if (!this.latestLongTrendPeriod?.redLineReached) return '"Not Okay" not expected soon';
    const reachedDate = new Date(this.latestLongTrendPeriod.redLineReached).getTime();

    const startStr = this.latestLongTrendPeriod?.start;
    if (!startStr) return '"Not Okay" not expected soon';
    const startTime = new Date(startStr).getTime();

    if (reachedDate < startTime) return '"Not Okay" not expected soon';
    if (reachedDate < Date.now()) {
      return `"Not Okay" was reached on ${this.$options.filters?.dateDMY(this.latestLongTrendPeriod?.redLineReached)}.`;
    } else {
      return `Changes to "Not Okay" ${this.$options.filters?.dateDMY(this.latestLongTrendPeriod?.redLineReached)}.`;
    }
  }

  get showPredictionByStatus(): string {
    const status = this.latestLongTrendPeriod?.status;
    if (status === "Ok") {
      return this.yellowPrediction;
    }
    if (status === "Observe") {
      return this.redPrediction;
    }
    if (status === "BenchMarking") {
      return "No prediction available";
    }
    if (status === "NotOk") {
      return "At lowest performance threshold";
    }
    return "";
  }
  //  @Methods
  async fetchData(): Promise<void> {
    if (!this.currentVessel) return;
    try {
      // fetch basic diagnostics data
      await Promise.all([VesselEvents.fetchEvents(this.currentVessel.id), VesselEvents.updateTrendEventTypes(), LongTrends.fetchVesselLongTrends(this.currentVessel.id)]);
      await LongTrends.fetchVesselLongTrendPeriods({ vesselId: this.currentVessel.id, longTrend: this.longTrend });
      // fetch Diagnostics config so OperationalProfileCard watcher and date range work
      try {
        await Diagnostics.fetchSpeedLossStatistics(this.currentVessel.id);
        await Diagnostics.fetchDiagnosticsChartConfig(this.currentVessel.id);
        const fetched = await Diagnostics.fetchDiagnosticsChartConfig(this.currentVessel.id);
        this.diagnosticsChartConfig = fetched ?? ({} as DiagnosticsChartConfig);
        this.addedFuelConsumptions = await Fouling.fetchAddedFuelConsumption(this.currentVessel.id);
        this.operationalProfileDateRange = [this.diagnosticsChartConfig.opFromDate, this.diagnosticsChartConfig.opToDate];
      } catch {
        // non-blocking: diagnostics should still load if Diagnostics config is unavailable
      }
      await this.fetchSpeedLog();
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to load vessel long trends" });
    } finally {
      this.isDataLoading = false;
    }
  }

  async fetchSpeedLog(): Promise<void> {
    try {
      await DataQuality.fetchSpeedLog(this.speedLogQuery);
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to fetch speed log data" });
    }
  }

  async onCurrentLongTrendChanged($event: string): Promise<void> {
    if (!this.currentVessel || Boolean($event === "Overview")) return;
    await LongTrends.fetchVesselLongTrendPeriods({ vesselId: this.currentVessel.id, longTrend: this.longTrend });
  }

  async onFilteringSettingsUpdated(): Promise<void> {
    if (!this.currentVessel) return;
    this.isDataLoading = true;
    try {
      //  TODO: Should we just use fetchData() here?
      await Promise.all([VesselEvents.fetchEvents(this.currentVessel.id), VesselEvents.updateTrendEventTypes(), LongTrends.fetchVesselLongTrends(this.currentVessel.id)]);
      await LongTrends.fetchVesselLongTrendPeriods({ vesselId: this.currentVessel.id, longTrend: this.longTrend });

      await Fouling.fetchSpeedLossHistory({ vesselId: this.currentVessel.id });
      await Fouling.fetchSpeedLossStatistics(this.currentVessel.id);
      this.addedFuelConsumptions = await Fouling.fetchAddedFuelConsumption(this.currentVessel.id);
      this.$emit("refetchPropulsionEfficiencyData");
    } catch (e) {
      Snackbar.showSnackbar({ text: "Failed to update data" });
    } finally {
      this.isDataLoading = false;
    }
  }

  longTrendShortDescription(longTrend: ILongTrend): string {
    if (!longTrend.descriptionLong) return "";
    return longTrend.description.split(",")[0] ?? "";
  }

  longTrendPerformanceIcon(longTrend: ILongTrend): string {
    if (longTrend.performanceStatus === "Ok") return "$StatusOk";
    if (longTrend.performanceStatus === "Observe") return "$StatusObserve";
    if (longTrend.performanceStatus === "NotOk") return "$StatusNotOk";
    if (longTrend.performanceStatus === "BenchMarking") return "$StatusBenchmarking";
    return "mdi-close-circle-outline";
  }

  convertStatusStr(performanceStatus: string): string {
    if (!performanceStatus) return "Unknown";
    if (performanceStatus === "Ok") return "Okay";
    if (performanceStatus === "NotOk") return "Not Okay";
    if (performanceStatus === "BenchMarking") return "Benchmarking";
    return performanceStatus ?? "Unknown";
  }

  async exportExcel(): Promise<void> {
    if (!this.currentVessel) return;
    this.exportExcelLoading = true;
    try {
      await LongTrendExportClient.exportExcel(this.currentVessel.id);
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to export data to Excel", color: "error" });
    } finally {
      setTimeout(() => {
        this.exportExcelLoading = false;
        Snackbar.showSnackbar({ text: "Export completed", color: "ContentPrimaryStatic" });
      }, 1000);
    }
  }

  async deleteEvent(vesselEvent: VesselEvent): Promise<void> {
    const confirmed = await this.ConfirmDelete.open("Delete Event", `Are you sure you want to delete <b>${vesselEvent.name}</b> event?`);
    if (confirmed) {
      await VesselEvents.deleteEvent(vesselEvent);
      Snackbar.showSnackbar({ text: `Event ${vesselEvent.name} successfully deleted`, color: "ContentPrimaryStatic" });
      this.currentVessel ? LongTrends.fetchVesselLongTrends(this.currentVessel.id) : null;
    }
  }

  markerClicked(marker: any): void {
    // If a SpeedLossChart ref exists in this page it will zoom; otherwise no-op.
    if ((this as any).SpeedLossChartCard && (this as any).SpeedLossChartCard.zoomIn) {
      (this as any).SpeedLossChartCard.zoomIn(moment.utc(marker.lastExportDate).valueOf(), moment.utc(marker.lastExportDate).valueOf());
    }
  }

  trackClicked(dates: { trackDateStart: string; trackDateEnd: string }): void {
    if ((this as any).SpeedLossChartCard && (this as any).SpeedLossChartCard.zoomIn) {
      (this as any).SpeedLossChartCard.zoomIn(moment.utc(dates.trackDateStart).valueOf(), moment.utc(dates.trackDateEnd).valueOf());
    }
  }

  syncSpeedLossChartDates(datesRange: { min: number; max: number; zoomedOut: boolean }): void {
    if ((this as any).SpeedLossChartCard && (this as any).SpeedLossChartCard.zoomIn) {
      (this as any).SpeedLossChartCard.zoomIn(datesRange.min, datesRange.max, datesRange.zoomedOut);
    }
  }

  showDiagnosticsDetails(data: any): void {
    if (!data.vesselId || !data.longTrendName) return;
    this.selectedDiagnosticsTrend = data.longTrendName;
    this.DiagnosticsDetails.open(data);
  }

  setHullCoating(): void {
    this.HullCoatingModal.open();
  }

  //  @Hooks
  async created(): Promise<void> {
    if (!LogVariables.currentVesselLogVariables.length) await LogVariables.refreshCurrentVesselLogVariables(parseInt(this.$route.params.vesselId));
    await this.fetchData();
  }
}
